import { tv } from 'tailwind-variants';

import { createEnumVariants } from '../../../utils/commonTailwindVariants.utils';

export enum ModalWidth {
  '2XL' = '2xl',
  '3XL' = '3xl',
  FULL = 'full',
  LG = 'lg',
  MD = 'md',
  NINE_TWENTY = '920',
  SM = 'sm',
  TWELVE_HUNDRED = '1200',
  XL = 'xl'
}

type ModalSlots = 'content' | 'closeButton';

export const modalStyles = tv({
  slots: {
    content:
      'bg-primary-modal-bg relative my-4 flex w-full flex-col rounded-xl shadow-xl max-h-[100vh]',

    closeButton: 'absolute right-2 top-2 z-10'
  },
  variants: {
    width: createEnumVariants<typeof ModalWidth, never, ModalSlots>({
      [ModalWidth.SM]: { content: 'max-w-sm' },
      [ModalWidth.MD]: { content: 'max-w-md' },
      [ModalWidth.LG]: { content: 'max-w-lg' },
      [ModalWidth.XL]: { content: 'max-w-xl' },
      [ModalWidth['2XL']]: { content: 'max-w-2xl' },
      [ModalWidth['3XL']]: { content: 'max-w-3xl' },
      [ModalWidth.NINE_TWENTY]: { content: 'max-w-[920px]' },
      [ModalWidth.TWELVE_HUNDRED]: { content: 'max-w-[1200px]' },
      [ModalWidth.FULL]: { content: 'max-w-full' }
    }),

    noContentPadding: {
      true: { content: '' },
      false: { content: 'p-8' }
    },

    hasCloseButton: {
      true: { content: '' },
      false: { content: 'pt-10' }
    },

    overflowAuto: {
      true: { content: 'overflow-y-auto' },
      false: { content: '' }
    }
  },
  compoundVariants: [
    {
      noContentPadding: false,
      hasCloseButton: false,
      class: { content: 'pt-10' }
    }
  ]
});
